const urls = {
  base: '/',
};

export function homeUrl() {
  return urls.base;
}

export default urls;